import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedAngularMaterialModule } from '../shared-angular-material/shared-angular-material.module';
import { SharedPipesModule } from '../shared-pipes/shared-pipes.module';
import { HasDryEyeSideEffect } from './dry-eye-side-effect-flagging/has-dry-eye-side-effect.pipe';
import { MedicationLookupComponent } from './medication-lookup.component';
import { SideEffectsPipe } from './side-effects.pipe';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    NgOptionHighlightModule,
    ReactiveFormsModule,
    SharedAngularMaterialModule,
    SharedPipesModule,
    TranslocoModule
  ],
  declarations: [MedicationLookupComponent, HasDryEyeSideEffect],
  exports: [MedicationLookupComponent, HasDryEyeSideEffect],
  providers: [SideEffectsPipe]
})
export class MedicationLookupModule {}
